import React, { forwardRef } from 'react';
type TextInputProps = {
  value: string;
  onChange: (v: string) => void;
  onEnter?: () => void;
  placeholder?: string;
  type?: 'text' | 'email';
  multiline?: boolean;
  error?: string | null;
};
export const TextInput = forwardRef<HTMLInputElement | HTMLTextAreaElement, TextInputProps>(function TextInput({
  value,
  onChange,
  onEnter,
  placeholder,
  type = 'text',
  multiline,
  error
}, ref) {
  const baseClasses = 'w-full bg-transparent text-white text-lg sm:text-2xl md:text-3xl font-light placeholder:text-neutral-600 border-b focus:outline-none transition-colors py-2 sm:py-3';
  const borderClasses = error ? 'border-red-400/70 focus:border-red-400' : 'border-white/30 focus:border-white';
  const handleKey = (e: React.KeyboardEvent) => {
    if (multiline) {
      if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        onEnter?.();
      }
      return;
    }
    if (e.key === 'Enter') {
      e.preventDefault();
      onEnter?.();
    }
  };
  return <div className="w-full" data-id="element-41">
      {multiline ? <textarea ref={ref as React.Ref<HTMLTextAreaElement>} value={value} onChange={e => onChange(e.target.value)} onKeyDown={handleKey} placeholder={placeholder} rows={3} className={`${baseClasses} ${borderClasses} resize-none`} data-id="element-42" /> : <input ref={ref as React.Ref<HTMLInputElement>} type={type} value={value} onChange={e => onChange(e.target.value)} onKeyDown={handleKey} placeholder={placeholder} autoComplete="off" className={`${baseClasses} ${borderClasses}`} data-id="element-43" />}
      {error && <p className="text-red-400 text-sm mt-2" data-id="element-44">{error}</p>}
    </div>;
});